
import { useEffect } from 'react'
import { useUIStore } from '../../store/uiStore.js'
import iconSonar from '../../assets/ui/icon-sonar.svg'

/** Shows the integer count overlay when a sonar ping result comes in */
export function SonarResult() {
  const lastSonarCount = useUIStore(s => s.lastSonarCount)

  useEffect(() => {
    if (lastSonarCount === null) return
    const timer = setTimeout(() => {
      useUIStore.getState().setLastSonarCount(null)
    }, 3000)
    return () => clearTimeout(timer)
  }, [lastSonarCount])

  if (lastSonarCount === null) return null

  return (
    <div style={{
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'rgba(0, 0, 0, 0.85)',
      color: '#4fc3f7',
      fontSize: 48,
      fontWeight: 700,
      padding: '24px 48px',
      borderRadius: 12,
      border: '2px solid #3DDC97',
      zIndex: 100,
      textAlign: 'center',
      cursor: 'pointer',
    }}
    onClick={() => useUIStore.getState().setLastSonarCount(null)}
    >
      <img
        src={iconSonar}
        alt="Sonar"
        style={{ width: 48, height: 48, marginBottom: 8 }}
        draggable={false}
      />
      <div style={{ fontSize: 14, marginBottom: 8, color: '#8DA9C4' }}>
        SONAR PING
      </div>
      <div>{lastSonarCount}</div>
      <div style={{ fontSize: 12, marginTop: 8, color: '#A6C6E1' }}>
        ship segments detected
      </div>
    </div>
  )
}
